export interface WasmThreadPolicy {
  /** Null preserves the existing default instead of selecting an A/B override. */
  requested: 1 | 2 | 4 | null;
  configured: number;
  hardwareConcurrency: number;
  isolated: boolean;
  invalidOverride: boolean;
}

/** Resolve one explicit benchmark flag before ORT initializes its global WASM pool. */
export function wasmThreadPolicy(
  search: string,
  hardwareConcurrency: number | undefined,
  isolated: boolean,
  defaultThreads: 1 | 4 = 4,
): WasmThreadPolicy {
  const values = new URLSearchParams(search).getAll("wasmthreads");
  const valid = values.length === 1 && /^(1|2|4)$/.test(values[0]);
  const requested = valid ? (Number(values[0]) as 1 | 2 | 4) : null;
  const cores =
    hardwareConcurrency !== undefined && Number.isFinite(hardwareConcurrency)
      ? Math.max(1, Math.floor(hardwareConcurrency))
      : 1;
  return {
    requested,
    configured: isolated ? Math.min(requested ?? defaultThreads, cores) : 1,
    hardwareConcurrency: cores,
    isolated,
    invalidOverride: values.length > 0 && !valid,
  };
}
